import { Network, OpenSeaPort } from 'opensea-js'
import { useEffect, useState } from 'react'
import Web3 from 'web3'

import { isMainnet } from '@/lib/MetaMaskUtil'

export type OpenSeaState = {
  seaport: OpenSeaPort | null
}

type Options = {
  web3: Web3 | null
  currentChainId: string | null
}

export const useOpenSea = ({ web3, currentChainId }: Options): OpenSeaState => {
  const [seaport, setSeaport] = useState<OpenSeaPort | null>(null)

  useEffect(() => {
    if (!web3 || !currentChainId) {
      setSeaport(null)
      return
    }

    const seaport = new OpenSeaPort(web3.currentProvider, {
      networkName: isMainnet(currentChainId) ? Network.Main : Network.Rinkeby,
    })
    setSeaport(seaport)
  }, [web3, currentChainId])

  return { seaport }
}
